"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { cn } from "@/utils/helpers";
import { Star } from "lucide-react";
import { useState } from "react";
import ReviewForm from "../form/review-form";
type AddReviewCardProps = {
  courseId: string;
};
export default function AddReviewCard(t0) {
  const $ = _c(16);
  const {
    courseId
  } = t0;
  const [rating, setRating] = useState(0);
  const [tempRating, setTempRating] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h4 className="text-lg font-bold">Rate this course</h4>;
    t2 = <p className="text-sm">Tell other students what you think</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Array.from({
      length: 5
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== tempRating) {
    t4 = <div className="mb-6 mt-8 flex gap-10">{t3.map((_, i) => {
        const starNumber = i + 1;
        return <Star key={i} size={22} className={cn("cursor-pointer stroke-muted-foreground", starNumber <= tempRating && "fill-reviewStar stroke-reviewStar")} onMouseEnter={() => setTempRating(starNumber)} onMouseLeave={() => setTempRating(0)} onClick={() => {
          setRating(starNumber);
          setIsOpen(true);
        }} />;
      })}</div>;
    $[3] = tempRating;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogTrigger asChild={true}><Button variant="outline" size="sm" className="-ml-1 text-xs text-blue-900 dark:text-foreground">Write a review</Button></DialogTrigger>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DialogHeader><DialogTitle>Add review</DialogTitle><DialogDescription>Reviews are public</DialogDescription></DialogHeader>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== courseId || $[8] !== rating) {
    t7 = <DialogContent>{t6}<ReviewForm rating={rating} courseId={courseId} setRating={setRating} setIsOpen={setIsOpen} /></DialogContent>;
    $[7] = courseId;
    $[8] = rating;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isOpen || $[11] !== t7) {
    t8 = <Dialog open={isOpen} onOpenChange={setIsOpen}>{t5}{t7}</Dialog>;
    $[10] = isOpen;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <div className="rounded-2xl border bg-background p-8 pt-6 shadow-sm">{t1}{t2}{t4}{t8}</div>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}